<template>
    <div class="test-from-editor">
        <h2 class="question__title mb-8" :class="{'question__compact': question.length>100}" v-html="question"></h2>
        <div class="row justify-center">
            <form @submit.prevent="onClickAnswer">
                <v-btn class="btn-disabled-primary mb-4" type="submit" x-large color="primary" :loading="loading">
                    Продолжить
                </v-btn>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'ConstructorTest',
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters({
            testData: 'testing/testing/testData',
            loading: 'testing/testing/loading',
        }),
        question() {
            return `<span>${this.testData.question.text}<span>`;
        },
    },
    methods: {
        ...mapActions({
            sendAnswerStaticMessage: 'testing/testing/sendAnswerStaticMessage',
        }),
        onClickAnswer() {
            this.sendAnswerStaticMessage();
        },
    },
};
</script>

<style scoped lang="scss">
</style>
